import { useEffect } from 'react';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { useBuildCommonFQEventProperties } from 'Views/FreemiumEntry/HasRelationship/Content/Components/utils';

export const useLogFQImpressionEvents = (collection) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { buildCommonFQEventProperties } = useBuildCommonFQEventProperties();

  useEffect(() => {
    const resource = collection.resources().head();
    if (resource) {
      const resourceType = resource.meta().type();
      let eventType;
      let additionalProperties = {};
      switch (resourceType) {
        case 'FQResponsePicklistQuestion':
        case 'FQResponseMultiPicklistQuestion':
          eventType = eventTypes.question;
          additionalProperties = {
            sectionId: resource.attr('sectionId'),
            questionId: resource.attr('questionId'),
            questionText: resource.attr('questionText'),
            questionReferenceName: resource.attr('questionReferenceName'),
          };
          break;
        case 'FQResponsePaymentPage':
          eventType = eventTypes.processCreditCard;
          break;
        case 'FoundationsPaymentCompleted':
          eventType = eventTypes.completed;
          additionalProperties = {
            isEmailVerificationSentScreen: true,
          };
          break;
        case 'FQResponseContactInformation':
        case 'FQResponseContactAndQualificationInformation':
        case 'FQResponseContactAndQualificationInformationReferee':
        case 'FQResponseContactAndInfluencerInformation':
          eventType = eventTypes.contactForm;
          break;
        case 'StandardEQFFQResponseCompleted':
          eventType = eventTypes.completed;
          logStandardizedEvent(categories.facetQuiz, eventTypes.completed, eventSubTypes.impression, {
            eventProperties: {
              ...buildCommonFQEventProperties(resource),
            },
          });
          break;
        default:
          // The majority of the resource types are insights
          eventType = eventTypes.insight;
          additionalProperties = {
            insightText: resource.attr('title'),
            insightId: resource.attr('insightId'),
            insightReferenceName: resource.attr('insightReferenceName'),
          };
      }
      logStandardizedEvent(categories.facetQuiz, eventType, eventSubTypes.impression, {
        eventProperties: {
          ...buildCommonFQEventProperties(resource),
          ...additionalProperties,
        },
      });
    }
  }, [collection]);
};
